import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/lepcso/00001.jpg'
import i00002 from '../images/lepcso/00002.jpg'
import i00003 from '../images/lepcso/00003.jpg'
import i00004 from '../images/lepcso/00004.jpg'
import i00005 from '../images/lepcso/00005.jpg'
import i00006 from '../images/lepcso/00006.jpg'
import i00007 from '../images/lepcso/00007.jpg'
import i00008 from '../images/lepcso/00008.jpg'
import i00009 from '../images/lepcso/00009.jpg'
import i00010 from '../images/lepcso/00010.jpg'
import i00011 from '../images/lepcso/00011.jpg'
import i00012 from '../images/lepcso/00012.jpg'
import i00013 from '../images/lepcso/00013.jpg'
import i00014 from '../images/lepcso/00014.jpg'
import i00015 from '../images/lepcso/00015.jpg'
import i00016 from '../images/lepcso/00016.jpg'
import i00017 from '../images/lepcso/00017.jpg'
import i00018 from '../images/lepcso/00018.jpg'
import i00019 from '../images/lepcso/00019.jpg'
import i00020 from '../images/lepcso/00020.jpg'
import i00021 from '../images/lepcso/00021.jpg'
import i00022 from '../images/lepcso/00022.jpg'
import i00023 from '../images/lepcso/00023.jpg'
import i00024 from '../images/lepcso/00024.jpg'
import i00025 from '../images/lepcso/00025.jpg'
import i00026 from '../images/lepcso/00026.jpg'
import i00027 from '../images/lepcso/00027.jpg'
import i00028 from '../images/lepcso/00028.jpg'
import i00029 from '../images/lepcso/00029.jpg'
import i00030 from '../images/lepcso/00030.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,
    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Lépcső kivitelezés</Title>
      </Section>
      <Section>
        <SubTitle>Hagyományos lépcső</SubTitle>
        <p>
          Első feladat a lépcső tervezése, melyhez a 2m+sz= 63-64 cm képletet alkalmazzuk. Utána felrajzoljuk a
          lépcsőfokokat a lemezvastagsággal együtt. A főfalakat a befogatás végett kivéssük. Hagyományos fa zsaluzatot
          készítünk alátámasztással. Elhelyezzük a méretezett vasalást, ezután következhet a lépcsőfokok zsaluzatának
          elhelyezése, kiegészítő vasalása. A lépcsőfok zsalukat megerősítjük távtartókkal, hogy a beton nyomását
          kibírják. Következhet a lépcső betonozása, tömörítése, simítása. Utókezelés vízzel, 1 hétig. A zsaluzat 28
          napos korában bontható ki!
        </p>
      </Section>
      <Section>
        <SubTitle>Gipszlépcső</SubTitle>
        <p>
          A dermesztett (gipsz) betonok olyan speciális vékony falú teherhordó anyagok, szerkezetek, melyeknél a beton
          kiöntéséhez szükséges többlet vízmennyiséget az előregyártott gipsz zsaluzat hamar elszívja, így tömörítve a
          betont.
        </p>
        <p>A gipsz zsaluzóelemek.</p>
        <p>Előregyártott elemek, melynek méretre vágásával alakítjuk ki a megtervezett lépcsőt.</p>
      </Section>
      <Section>
        <SubTitle>Szerkezetépítés</SubTitle>
        <p>
          A gipsz zsaluzóelem táblákból (600mmx600mm), függőleges és vízszintes elemeket állítunk össze műanyag távtartó
          betétek alkalmazásával. A távtartók adják a vasalás helyét, szerkezeten belüli rögzítését. Elvégezzük a bordák
          vasalását 4-8 mm acél pálcákkal, majd úgynevezett „folyós konzisztenciájú”4mm homokos kavics betonnal öntjük
          ki a szerkezetet. A lépcső belépőjét dörzsölt felületképzéssel látjuk el. Szilárdulás után, bármilyen burkoló
          anyaggal burkolható!
        </p>
        <p>
          <strong>A gipszbetonlépcső előnyei:</strong>
        </p>
        <ul>
          <li>egyszerű felépítésű</li>
          <li>előállítása gyorsan, kis energiaigénnyel, gazdaságosan valósítható meg</li>
          <li>könnyebb, mint a hagyományos lépcső</li>
          <li>kombinálja a hagyományos vasbeton lépcső tartósságát </li>
          <li>a vasszerkezetek alakíthatóságával </li>
          <li>könnyű, vékony bordázatú, stabil és időálló, rugalmas, anyaga nem éghető, környezetbarát, </li>
          <li>
            építése során kiküszöbölhető a homokbeton tömörítése, utókezelése, kicsi a szállítási súlya, az agyagok kézi
            úton mozgatható
          </li>
          <li>akár 48-72 órán belül elkészül, negyedik napon használható!</li>
          <li>nem kell kivárni a 28 napos szilárdulási időt</li>
          <li>könnyen felületkezelhető </li>
          <li>festhető </li>
          <li>tapétázható </li>
          <li>bármilyen burkolattal ellátható </li>
          <li>igény esetén korlátépítésre is alkalmas </li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
          <img src={i00008} alt="" />
          <img src={i00009} alt="" />
          <img src={i00010} alt="" />
          <img src={i00011} alt="" />
          <img src={i00012} alt="" />
          <img src={i00013} alt="" />
          <img src={i00014} alt="" />
          <img src={i00015} alt="" />
          <img src={i00016} alt="" />
          <img src={i00017} alt="" />
          <img src={i00018} alt="" />
          <img src={i00019} alt="" />
          <img src={i00020} alt="" />
          <img src={i00021} alt="" />
          <img src={i00022} alt="" />
          <img src={i00023} alt="" />
          <img src={i00024} alt="" />
          <img src={i00025} alt="" />
          <img src={i00026} alt="" />
          <img src={i00027} alt="" />
          <img src={i00028} alt="" />
          <img src={i00029} alt="" />
          <img src={i00030} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
